import { villageAddApi } from "../../api/village/villageAddApi"

type PayloadShape = Parameters<typeof villageAddApi>[0]

export async function villageAddService(payload: PayloadShape, token: string) {
	return await villageAddApi(payload, token)
}
